module.exports = __webpack_public_path__ + "img/sfjc.d4b1f9ff.png";